import * as __SNOWPACK_ENV__ from '../../../_snowpack/env.js';

import './SearchResultPanel.svelte.css';
/* src/components/searchResult/SearchResultPanel.svelte generated by Svelte v3.46.4 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	check_outros,
	component_subscribe,
	create_bidirectional_transition,
	destroy_each,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	safe_not_equal,
	set_data,
	space,
	src_url_equal,
	text,
	transition_in,
	transition_out
} from "../../../_snowpack/pkg/svelte/internal.js";

import { fade } from '../../../_snowpack/pkg/svelte/transition.js';
import { searchResult } from '../../stores/storeSearchResult.js';

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[2] = list[i];
	return child_ctx;
}

// (8:0) {#if $searchResult && $searchResult.item}
function create_if_block(ctx) {
	let ul;
	let ul_transition;
	let current;
	let each_value = /*$searchResult*/ ctx[0].item;
	let each_blocks = [];

	for (let i = 0; i < each_value.length; i += 1) {
		each_blocks[i] = create_each_block(get_each_context(ctx, each_value, i));
	}

	return {
		c() {
			ul = element("ul");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(ul, "id", "search-result");
			attr(ul, "class", "search-result svelte-dqbvld");
		},
		m(target, anchor) {
			insert(target, ul, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(ul, null);
			}

			current = true;
		},
		p(ctx, dirty) {
			if (dirty & /*$searchResult, url*/ 3) {
				each_value = /*$searchResult*/ ctx[0].item;
				let i;

				for (i = 0; i < each_value.length; i += 1) {
					const child_ctx = get_each_context(ctx, each_value, i);

					if (each_blocks[i]) {
						each_blocks[i].p(child_ctx, dirty);
					} else {
						each_blocks[i] = create_each_block(child_ctx);
						each_blocks[i].c();
						each_blocks[i].m(ul, null);
					}
				}

				for (; i < each_blocks.length; i += 1) {
					each_blocks[i].d(1);
				}

				each_blocks.length = each_value.length;
			}
		},
		i(local) {
			if (current) return;

			add_render_callback(() => {
				if (!ul_transition) ul_transition = create_bidirectional_transition(ul, fade, { delay: 250, duration: 300 }, true);
				ul_transition.run(1);
			});

			current = true;
		},
		o(local) {
			if (!ul_transition) ul_transition = create_bidirectional_transition(ul, fade, { delay: 250, duration: 300 }, false);
			ul_transition.run(0);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(ul);
			destroy_each(each_blocks, detaching);
			if (detaching && ul_transition) ul_transition.end();
		}
	};
}

// (48:6) {:else}
function create_else_block(ctx) {
	let t0;
	let t1_value = /*item*/ ctx[2][11] + "";
	let t1;
	let t2;
	let em;
	let t3;
	let t4_value = /*item*/ ctx[2][12] + "";
	let t4;

	return {
		c() {
			t0 = text("価格：￥");
			t1 = text(t1_value);
			t2 = text(" → ");
			em = element("em");
			t3 = text("￥");
			t4 = text(t4_value);
			attr(em, "class", "svelte-dqbvld");
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, t1, anchor);
			insert(target, t2, anchor);
			insert(target, em, anchor);
			append(em, t3);
			append(em, t4);
		},
		p(ctx, dirty) {
			if (dirty & /*$searchResult*/ 1 && t1_value !== (t1_value = /*item*/ ctx[2][11] + "")) set_data(t1, t1_value);
			if (dirty & /*$searchResult*/ 1 && t4_value !== (t4_value = /*item*/ ctx[2][12] + "")) set_data(t4, t4_value);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
			if (detaching) detach(t2);
			if (detaching) detach(em);
		}
	};
}

// (45:6) {#if '1' === item[3]}
function create_if_block_1(ctx) {
	let t0;
	let t1_value = /*item*/ ctx[2][11] + "";
	let t1;
	let t2;
	let em;
	let t3;
	let t4_value = /*item*/ ctx[2][12] + "";
	let t4;
	let br;
	let t5;
	let span;
	let t6;
	let t7_value = /*item*/ ctx[2][13] + "";
	let t7;

	return {
		c() {
			t0 = text("価格：￥");
			t1 = text(t1_value);
			t2 = text(" → ");
			em = element("em");
			t3 = text("￥");
			t4 = text(t4_value);
			br = element("br");
			t5 = space();
			span = element("span");
			t6 = text("サイズ:");
			t7 = text(t7_value);
			attr(em, "class", "svelte-dqbvld");
			attr(span, "class", "fs-9px svelte-dqbvld");
		},
		m(target, anchor) {
			insert(target, t0, anchor);
			insert(target, t1, anchor);
			insert(target, t2, anchor);
			insert(target, em, anchor);
			append(em, t3);
			append(em, t4);
			insert(target, br, anchor);
			insert(target, t5, anchor);
			insert(target, span, anchor);
			append(span, t6);
			append(span, t7);
		},
		p(ctx, dirty) {
			if (dirty & /*$searchResult*/ 1 && t1_value !== (t1_value = /*item*/ ctx[2][11] + "")) set_data(t1, t1_value);
			if (dirty & /*$searchResult*/ 1 && t4_value !== (t4_value = /*item*/ ctx[2][12] + "")) set_data(t4, t4_value);
			if (dirty & /*$searchResult*/ 1 && t7_value !== (t7_value = /*item*/ ctx[2][13] + "")) set_data(t7, t7_value);
		},
		d(detaching) {
			if (detaching) detach(t0);
			if (detaching) detach(t1);
			if (detaching) detach(t2);
			if (detaching) detach(em);
			if (detaching) detach(br);
			if (detaching) detach(t5);
			if (detaching) detach(span);
		}
	};
}

// (14:2) {#each $searchResult.item as item}
function create_each_block(ctx) {
	let li;
	let a0;
	let img;
	let img_src_value;
	let img_alt_value;
	let a0_href_value;
	let t0;
	let p0;
	let b0;
	let t1_value = /*item*/ ctx[2][7] + "";
	let t1;
	let t2;
	let h3;
	let a1;
	let ruby;
	let rb;
	let t3_value = /*item*/ ctx[2][6] + "";
	let t3;
	let t4;
	let rp0;
	let t6;
	let rt;
	let t7_value = /*item*/ ctx[2][9] + "";
	let t7;
	let t8;
	let rp1;
	let t10;
	let br;
	let t11;
	let span0;
	let t12_value = /*item*/ ctx[2][5] + /*item*/ ctx[2][8] + "";
	let t12;
	let a1_href_value;
	let t13;
	let div;
	let p1;
	let t14_value = /*item*/ ctx[2][10] + "";
	let t14;
	let t15;
	let p2;
	let t16;
	let p3;
	let t20;
	let p4;
	let b1;
	let t21_value = /*item*/ ctx[2][5] + "";
	let t21;
	let t22;
	let li_id_value;

	function select_block_type(ctx, dirty) {
		if ('1' === /*item*/ ctx[2][3]) return create_if_block_1;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			li = element("li");
			a0 = element("a");
			img = element("img");
			t0 = space();
			p0 = element("p");
			b0 = element("b");
			t1 = text(t1_value);
			t2 = space();
			h3 = element("h3");
			a1 = element("a");
			ruby = element("ruby");
			rb = element("rb");
			t3 = text(t3_value);
			t4 = space();
			rp0 = element("rp");
			rp0.textContent = "《";
			t6 = space();
			rt = element("rt");
			t7 = text(t7_value);
			t8 = space();
			rp1 = element("rp");
			rp1.textContent = "》";
			t10 = space();
			br = element("br");
			t11 = space();
			span0 = element("span");
			t12 = text(t12_value);
			t13 = space();
			div = element("div");
			p1 = element("p");
			t14 = text(t14_value);
			t15 = space();
			p2 = element("p");
			if_block.c();
			t16 = space();
			p3 = element("p");

			p3.innerHTML = `<span class="item-tag-cm svelte-dqbvld">カスタマイズ可</span> 
						<span class="item-tag-sale svelte-dqbvld">30%OFFSALE</span>`;

			t20 = space();
			p4 = element("p");
			b1 = element("b");
			t21 = text(t21_value);
			t22 = space();
			if (!src_url_equal(img.src, img_src_value = /*item*/ ctx[2][4])) attr(img, "src", img_src_value);
			attr(img, "alt", img_alt_value = /*item*/ ctx[2][7] + /*item*/ ctx[2][6] + /*item*/ ctx[2][5] + /*item*/ ctx[2][8]);
			attr(img, "width", "160");
			attr(img, "height", "160");
			attr(img, "loading", "lazy");
			attr(img, "class", "svelte-dqbvld");
			attr(a0, "class", "item-thumb svelte-dqbvld");
			attr(a0, "href", a0_href_value = "" + (/*url*/ ctx[1] + "/" + /*item*/ ctx[2][1] + "_" + /*item*/ ctx[2][2] + "_" + /*item*/ ctx[2][3] + "/"));
			attr(b0, "class", "svelte-dqbvld");
			attr(p0, "class", "item-design svelte-dqbvld");
			attr(rb, "class", "rb svelte-dqbvld");
			attr(rp0, "class", "rp");
			attr(rt, "class", "rt");
			attr(rp1, "class", "rp");
			attr(ruby, "class", "ruby");
			attr(span0, "class", "type_name svelte-dqbvld");
			attr(a1, "href", a1_href_value = "" + (/*url*/ ctx[1] + "/" + /*item*/ ctx[2][1] + "_" + /*item*/ ctx[2][2] + "_" + /*item*/ ctx[2][3] + "/"));
			attr(a1, "class", "svelte-dqbvld");
			attr(h3, "class", "item-name svelte-dqbvld");
			attr(p1, "class", "item-description svelte-dqbvld");
			attr(p2, "class", "item-price svelte-dqbvld");
			attr(p3, "class", "item-tag svelte-dqbvld");
			attr(b1, "class", "svelte-dqbvld");
			attr(p4, "class", "item-usestone svelte-dqbvld");
			attr(div, "class", "item-info svelte-dqbvld");
			attr(li, "id", li_id_value = "id_s_" + /*item*/ ctx[2][0]);
			attr(li, "class", "svelte-dqbvld");
		},
		m(target, anchor) {
			insert(target, li, anchor);
			append(li, a0);
			append(a0, img);
			append(li, t0);
			append(li, p0);
			append(p0, b0);
			append(b0, t1);
			append(li, t2);
			append(li, h3);
			append(h3, a1);
			append(a1, ruby);
			append(ruby, rb);
			append(rb, t3);
			append(ruby, t4);
			append(ruby, rp0);
			append(ruby, t6);
			append(ruby, rt);
			append(rt, t7);
			append(ruby, t8);
			append(ruby, rp1);
			append(a1, t10);
			append(a1, br);
			append(a1, t11);
			append(a1, span0);
			append(span0, t12);
			append(li, t13);
			append(li, div);
			append(div, p1);
			append(p1, t14);
			append(div, t15);
			append(div, p2);
			if_block.m(p2, null);
			append(div, t16);
			append(div, p3);
			append(div, t20);
			append(div, p4);
			append(p4, b1);
			append(b1, t21);
			append(li, t22);
		},
		p(ctx, dirty) {
			if (dirty & /*$searchResult*/ 1 && !src_url_equal(img.src, img_src_value = /*item*/ ctx[2][4])) {
				attr(img, "src", img_src_value);
			}

			if (dirty & /*$searchResult*/ 1 && img_alt_value !== (img_alt_value = /*item*/ ctx[2][7] + /*item*/ ctx[2][6] + /*item*/ ctx[2][5] + /*item*/ ctx[2][8])) {
				attr(img, "alt", img_alt_value);
			}

			if (dirty & /*$searchResult*/ 1 && a0_href_value !== (a0_href_value = "" + (/*url*/ ctx[1] + "/" + /*item*/ ctx[2][1] + "_" + /*item*/ ctx[2][2] + "_" + /*item*/ ctx[2][3] + "/"))) {
				attr(a0, "href", a0_href_value);
			}

			if (dirty & /*$searchResult*/ 1 && t1_value !== (t1_value = /*item*/ ctx[2][7] + "")) set_data(t1, t1_value);
			if (dirty & /*$searchResult*/ 1 && t3_value !== (t3_value = /*item*/ ctx[2][6] + "")) set_data(t3, t3_value);
			if (dirty & /*$searchResult*/ 1 && t7_value !== (t7_value = /*item*/ ctx[2][9] + "")) set_data(t7, t7_value);
			if (dirty & /*$searchResult*/ 1 && t12_value !== (t12_value = /*item*/ ctx[2][5] + /*item*/ ctx[2][8] + "")) set_data(t12, t12_value);

			if (dirty & /*$searchResult*/ 1 && a1_href_value !== (a1_href_value = "" + (/*url*/ ctx[1] + "/" + /*item*/ ctx[2][1] + "_" + /*item*/ ctx[2][2] + "_" + /*item*/ ctx[2][3] + "/"))) {
				attr(a1, "href", a1_href_value);
			}

			if (dirty & /*$searchResult*/ 1 && t14_value !== (t14_value = /*item*/ ctx[2][10] + "")) set_data(t14, t14_value);

			if (current_block_type === (current_block_type = select_block_type(ctx, dirty)) && if_block) {
				if_block.p(ctx, dirty);
			} else {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(p2, null);
				}
			}

			if (dirty & /*$searchResult*/ 1 && t21_value !== (t21_value = /*item*/ ctx[2][5] + "")) set_data(t21, t21_value);

			if (dirty & /*$searchResult*/ 1 && li_id_value !== (li_id_value = "id_s_" + /*item*/ ctx[2][0])) {
				attr(li, "id", li_id_value);
			}
		},
		d(detaching) {
			if (detaching) detach(li);
			if_block.d();
		}
	};
}

function create_fragment(ctx) {
	let if_block_anchor;
	let current;
	let if_block = /*$searchResult*/ ctx[0] && /*$searchResult*/ ctx[0].item && create_if_block(ctx);

	return {
		c() {
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, [dirty]) {
			if (/*$searchResult*/ ctx[0] && /*$searchResult*/ ctx[0].item) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*$searchResult*/ 1) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let $searchResult;
	component_subscribe($$self, searchResult, $$value => $$invalidate(0, $searchResult = $$value));
	const url = __SNOWPACK_ENV__.SNOWPACK_PUBLIC_API_URL;
	return [$searchResult, url];
}

class SearchResultPanel extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default SearchResultPanel;